export default "__VITE_ASSET__AQO_jiI7__"